import PropTypes from 'prop-types';
import React from 'react';

import { Alert, NoticeIcon, NoticeMark } from 'common-src/components/base';

import { getDecisionRecord, getOutcomeTone } from './mocaPrompt';
import useMocaPrompt from './useMocaPrompt';

export const MocaOutcomeIcon = ({ appt, onClick }) => {
  const moca = useMocaPrompt(appt, 'Prepare');
  const { afterVisit } = moca.state;
  if (!appt?.lowMocaPrompt || !afterVisit) return null;

  const Icon = onClick ? NoticeIcon : NoticeMark;

  return (
    <Icon
      tone={getOutcomeTone(afterVisit)}
      label={afterVisit.text}
      detail={getDecisionRecord(moca.state)}
      onClick={onClick}
    />
  );
};

MocaOutcomeIcon.propTypes = { appt: PropTypes.object, onClick: PropTypes.func };

export const MocaOutcomeLine = ({ appt }) => {
  const moca = useMocaPrompt(appt, 'Prepare');
  const { afterVisit } = moca.state;
  if (!appt?.lowMocaPrompt || !afterVisit) return null;
  const record = getDecisionRecord(moca.state);

  return (
    <Alert variant={afterVisit.tone === 'warning' ? 'warning' : 'default'} title={afterVisit.text}>
      {record}
    </Alert>
  );
};

MocaOutcomeLine.propTypes = { appt: PropTypes.object };
